import axios from "axios";
import { Base_URL } from "../url";
import { toast } from "react-toastify";


export const saveAssetMasterDetails = async (assetData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/AssetsList/CreateAsset?UserName=${userName}`,
      assetData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save Asset Master";
  }
};

export const downloadAllAssetDataExcel = async () => {
  try {
    const res = await axios.post(
      `${Base_URL}/AssetsList/DownloadAssetsExcel`,
      null,
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return res;
  } catch (err) {
    // toast.error(`🦄 ${err.response.data.message}`);
    console.log('err from excel download', err)
  }
};




export const saveAssetAssignedDetails = async (assetData, userName) => {
  try {
    console.log(assetData, 'assetData')
    console.log(userName, 'userName')
    const response = await axios.post(
      `${Base_URL}/AssignAssets/AssignAsset?userName=${userName}`,
      assetData);
    return response.data;
  } catch (error) {
    console.log(error.response?.data, 'error.response?.data')
    throw error.response?.data || "Failed to Assigned";
  }
};


export const updateAssetMasterDetails = async (assetData, userName, categoryId) => {
  assetData.Asset_ID = categoryId;
  console.log(assetData, 'assetData')
  try {
    const response = await axios.put(
      `${Base_URL}/AssetsList/UpdateAsset?UserName=${userName}`,
      assetData);
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to update Asset Master";
  }
};

/// AssetService/AddService
export const saveAssetServiceDetails = async (assetData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/AssetService/AddService?UserName=${userName}`,
      assetData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save Asset Service Master";
  }
}; 


export const saveAssetStatus = async (assetData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/AssetStatus?UserName=${userName}`,
      assetData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save Asset Status";
  }
};

export const saveassetData = async () => {
  try{
    const res = await axios.post(`${Base_URL}/leads/dataleads`)
    console.log(res, 'res from save asset data when matched')
    return res;
  }catch(err){
    console.log('error at save asset details', err)
  }
}